module.exports = __webpack_public_path__ + "img/2-7.3dc536d1.svg";